import { render, staticRenderFns } from "./menber-info.vue?vue&type=template&id=639de9a9"
import script from "./menber-info.vue?vue&type=script&lang=js"
export * from "./menber-info.vue?vue&type=script&lang=js"
import style0 from "./menber-info.vue?vue&type=style&index=0&id=639de9a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports